import { Component, Inject, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-associate-crop-reconciliation-confirmation',
  templateUrl: './associate-crop-reconciliation-confirmation.component.html',
  styleUrl: './associate-crop-reconciliation-confirmation.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AssociateCropReconciliationConfirmationComponent implements OnDestroy {
  private subscription = new Array<Subscription>();
  displayedColumns = ['orderHeaderID', 'brand', 'previousQty', 'orderQty', 'status'];

  constructor(
    public dialogRef: MatDialogRef<AssociateCropReconciliationConfirmationComponent>,
    private toastrService: ToastrService,
    @Inject(MAT_DIALOG_DATA) public dataSource: any[]
  ) {}




  isFirstRowOfGroup(index: any): boolean {
    if (index === 0) return true;
    return this.dataSource[index].orderHeaderID !== this.dataSource[index - 1].orderHeaderID;
  }

  getRowSpan(orderHeaderID: any): number {
    return this.dataSource.filter(x => x.orderHeaderID === orderHeaderID).length;
  }

  ngOnInit(): void {
    if (this.dataSource == undefined || (this.dataSource && this.dataSource.length == 0)) {
      this.toastrService.warning('No records found for Update Reconciliation Confirmation.');
    }
    
  }

  ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }


  onCancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }

  onBackToSubmit() {
    this.dialogRef.close({ action: 'save' });
  }
}
